import axios from 'axios';
import Constants from '../constants';

export async function ClearDisplayLogicBySourceType(surveyId: number, conditionSourceTypeIds: number[]) {
	const url = getDisplayLogicUrl(surveyId, conditionSourceTypeIds);
	const res = await axios.delete(url);
	return res.status;
}

function getDisplayLogicUrl(surveyId: number, sourceTypeIds: number[]) {
	let url = Constants.API_DISPLAY_LOGIC.replace('{surveyId}', surveyId.toString()) + '?';
	sourceTypeIds.forEach((element, index) => {
		url += 'sourceTypeIds=' + element + (sourceTypeIds.length - 1 === index ? '' : '&');
	});
	return url;
}
